import { render, staticRenderFns } from "./garden29.vue?vue&type=template&id=a2d69ec6&scoped=true&"
import script from "./garden29.vue?vue&type=script&lang=js&"
export * from "./garden29.vue?vue&type=script&lang=js&"
import style0 from "./garden29.vue?vue&type=style&index=0&id=a2d69ec6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2d69ec6",
  null
  
)

export default component.exports